import { Icon, IconName } from 'ui/components/Icon'

import { s } from './styles'

export const ControlInfo = () => (
  <s.Box>
    <s.Inner>
      <s.Panel>
        <Icon name={IconName.MOVE_ARROWS} />
        <span>Move</span>
      </s.Panel>
      <s.Panel>
        <Icon name={IconName.ENTER_BUTTON} />
        <span>Select</span>
      </s.Panel>
      <s.Panel>
        <Icon name={IconName.ESCAPE_BUTTON} />
        <span>Exit</span>
      </s.Panel>
    </s.Inner>
  </s.Box>
)
